import { newVector, Vector } from '@lessonup/pins-shared';

export type Flag = 0 | 1;

/**
 * Building blocks to build an SVG path command.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d
 */
export const Path = {
  moveTo(pos: Vector) {
    return `M ${vectorSvg(pos)}`;
  },
  lineTo(pos: Vector) {
    return `L ${vectorSvg(pos)}`;
  },
  relativeLineTo(dpos: Vector) {
    return `l ${vectorSvg(dpos)}`;
  },
  relativeHorizontalLine(dx: number) {
    return `h ${dx}`;
  },
  arc(radius: Vector, rotationTurn: number, largeArcFlag: Flag, sweepFlag: Flag, end: Vector) {
    return `A ${vectorSvg(radius)} ${rotationTurn} ${largeArcFlag},${sweepFlag} ${vectorSvg(end)}`;
  },
  circleArc(radius: number, sweepTurn: number, endArc: Vector) {
    const largeArcFlag = sweepTurn <= 0.5 ? 0 : 1;
    return Path.arc(newVector(radius, radius), 0, largeArcFlag, 1, endArc);
  },
  closedPath(commands: string[]) {
    return [...commands, 'Z'].join(' ');
  },
};

function vectorSvg({ x, y }: Vector): string {
  return `${x},${y}`;
}
